import { render } from "./TouchMePageRelease.vue?vue&type=template&id=d7da8c76&scoped=true"
import script from "./TouchMePageRelease.vue?vue&type=script&lang=js"
export * from "./TouchMePageRelease.vue?vue&type=script&lang=js"

import "./TouchMePageRelease.vue?vue&type=style&index=0&id=d7da8c76&scoped=true&lang=css"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7da8c76"]])

export default __exports__